import type { StateCreator } from 'zustand';
import { CombinedStore } from '@/types/org.types';

export interface StoreState {
  currentStore: CombinedStore | null;
  setCurrentStore: (store: CombinedStore) => void;
}

export const createStoreState: StateCreator<StoreState> = (set) => ({
  currentStore: null,
  setCurrentStore: (store: CombinedStore) => set((state) => ({ ...state, currentStore: store }))
});
